import { v4 as uuidv4 } from 'uuid';

export enum HostAppRequestType {
    AddMinutesUsed = 'AddMinutesUsed'
}

enum HostAppMessageType {
    Request = 'request',
    Response = 'response'
}

type RequestId = string;

interface IHostAppMessage {
    transcriptionMessage: true,
    messageType: HostAppMessageType,
    requestType: HostAppRequestType,
    requestId: RequestId
}

interface IHostAppPendingRequest {
    resolvePromise: any,
    rejectPromise: any
}

export class HostAppMessenger {
    private messageQueue: IHostAppMessage[] = [];

    // pendingRequests is an object with RequestId keys and IHostAppPendingRequest values.
    private pendingRequests: { [K in RequestId]: IHostAppPendingRequest } = {};

    constructor() {
        // We receive messages (responses to our requests) from the host through onTranscriptionHostMessage.
        (<any>window).onTranscriptionHostMessage = (args: any) => { this.OnHostAppMessage(args); };

        // The hosts polls for new messages by calling getNewTranscriptionMessages.
        (<any>window).getNewTranscriptionMessages = (args: any) => { this.GetNewTranscriptionMessages(args); };
    }

    private OnHostAppMessage(args: any) {
        if (args == null) return;

        if (args.messageType != HostAppMessageType.Response || args.requestId == null || this.pendingRequests[args.requestId] == null) {
            args.completed();
            return;
        }

        const pendingRequest = this.pendingRequests[args.requestId];

        if (args.error != null) {
            pendingRequest.rejectPromise('Transcription host request failed with error: ' + args.error);
            args.completed();
            return;
        }

        args.completed();
        pendingRequest.resolvePromise(args);
    }

    private GetNewTranscriptionMessages(args: any) {
        if (this.messageQueue.length == 0) {
            args.completed();
            return;
        }

        args.completed(JSON.stringify(this.messageQueue));
        this.messageQueue = [];
    }

    public MakeRequest(requestType: HostAppRequestType, requestArgs?: any): Promise<any> {
        const requestId = uuidv4();
        
        this.messageQueue.push(
            {
                transcriptionMessage: true,
                messageType: HostAppMessageType.Request,
                requestId,
                requestType,
                ...requestArgs
            }
        );

        const requestPromise = new Promise((resolve, reject) => {
            this.pendingRequests[requestId] = {
                resolvePromise: resolve,
                rejectPromise: reject
            };
        });

        return requestPromise;
    }
}